import React, { Component } from 'react';

import SurveyIcon from '@material-ui/icons/ThumbUpTwoTone';
import FlatButton from 'material-ui/FlatButton';

import { titleize } from 'helpers/Formatter';
import { currentLocation } from 'helpers/CurrentWindowLocation';
import { AccentColor } from 'helpers/AccentColorHelper';

import { localize } from 'react-localize-redux';

class SurveyTodo extends Component {
  render() {
    const { surveyTitle, uuid, accessUUID } = this.props;

    const style = {
      second_tier: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-15px',
      },
    };

    return (
      <FlatButton
        onClick={() =>
          window.open(currentLocation() + `/survey?uuid=${uuid}&access_token=${accessUUID}`)}
        style={{
          fontSize: '15px',
          color: '#3e3e3e',
          width: '100%',
          height: '55px',
          textAlign: 'inherit',
        }}
        tabIndex="1"
      >
        <div>
          <div style={{ display: 'inline-block', margin: '0 33px 0 15px' }}>
            <SurveyIcon style={{ color: AccentColor() }} />
          </div>
          <div style={{ display: 'inline-block' }}>
            <p style={{ margin: 0 }}>
              {this.props.translate('todo.needFeedback')} <i className="em em-smiley" />
            </p>
            <p style={style.second_tier}>{titleize(surveyTitle)}</p>
          </div>
        </div>
      </FlatButton>
    );
  }
}

export default localize()(SurveyTodo);
